export interface QueueBatchItem {
	QueueBatchId: number;
	ObjectId: string;
	Status: QueueBatchItemStatus;
}

export enum QueueBatchItemStatus {
	Unknown = 0,
	Unprocessed = 1,
	Processed = 3,
	Completed = 4,
	Failed = 5,
}
